import { IconComponentsProps } from './types';

const ImportSupportiveDocumentsIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 1.5C12.0987 1.49943 12.1967 1.51834 12.2881 1.55566C12.3794 1.59298 12.4622 1.6483 12.5322 1.71777L17.7822 6.96777C17.8517 7.03781 17.907 7.1206 17.9443 7.21191C17.9817 7.30328 18.0006 7.4013 18 7.5V10.5H16.5V9H12C11.6022 9 11.2208 8.84185 10.9395 8.56055C10.6582 8.27924 10.5 7.89782 10.5 7.5V3H4.5V21H16.5V19.5H18V21C18 21.3978 17.8418 21.7792 17.5605 22.0605C17.2792 22.3419 16.8978 22.5 16.5 22.5H4.5C4.10218 22.5 3.72076 22.3419 3.43945 22.0605C3.15816 21.7792 3 21.3978 3 21V3C3.00001 2.60218 3.15815 2.22075 3.43945 1.93945C3.72076 1.65816 4.10218 1.5 4.5 1.5H12ZM13.0576 12.3076L11.1221 14.25H21V15.75H11.1221L13.0576 17.6924L12 18.75L8.25 15L12 11.25L13.0576 12.3076ZM12 7.5H16.1924L12 3.30762V7.5Z"
      fill={fill}
    />
  </svg>
);

export default ImportSupportiveDocumentsIcon;
